{
  "version": 1,
  "asset_id": "22066349-232b-48a3-a7f4-e7c4d68021a4",
  "project_id": "affbb9b7-8892-4de7-a6a3-a24f8c559459",
  "url": "/__l5e/assets-v1/22066349-232b-48a3-a7f4-e7c4d68021a4/pavimento-cotto-terrazza-lavato-brescia.webp",
  "r2_key": "a/v1/affbb9b7-8892-4de7-a6a3-a24f8c559459/22066349-232b-48a3-a7f4-e7c4d68021a4/pavimento-cotto-terrazza-lavato-brescia.webp",
  "original_filename": "pavimento-cotto-terrazza-lavato-brescia.webp",
  "size": 146828,
  "content_type": "image/webp",
  "created_at": "2026-08-13T06:52:17Z"
}
